import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rz4kea8jp: FaireProductEntity = {
  token: "p_2rz4kea8jp",
  type: "product",
  name: "Ethiopia Chelbesa One",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl: "https://cdn.faire.com/fastly/1fbc1ff71d720936eba0882edc5188d84f4c5c8ed1b001145c95506ad178db96.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/523dcb3705ede61c38919df1e0fc422c5dde99f23aa4d4bf9d3c53d7b1e3c7c6.jpeg",
    "https://cdn.faire.com/fastly/c818eafb97fa4cab3ffb36afea0f690773c20751547967402050b672a4b83cb8.png",
    "https://cdn.faire.com/fastly/304902a9ede1d2457741e791fdc12c82eba4291c734457db314a6de7c3bd0a87.png"
  ],
  priceDollars: 17.4,
  description: "Size: 12oz retail bag\nTaste Notes: Peach Tea, Honeycomb, Wipeout!\nRegion: Chelbesa, Gedeb, Gedeo, Ethiopia\nGrown By: ~1,000 farmers\nElevation: 1950-2200 masl\nVarieties: Korume, Wolisho\nProcessing: Washed \nSensory: Watermelon Juice, Prismatic, Layered, Orange Candy, Honey Stick, Waves\n\nListen, this might be news to you, but if you’re anywhere adjacent to the coffee world, you might have heard rumors that the 2025-2026 harvest coming from Ethiopia churned out some of the best coffees it has ever produced! \n\nWe are here to confirm that this rumor is 10000% true! In these days where field reports are grim with environmental woes, economic shocks and global warming confirmations, it’s incredible to witness the birthplace of all coffee see results so palpably upgraded!\n\n(Yes, exclamation marks at every paragraph end are necessary!)\n\nWitness this washed Ethiopia coffee from the Chelbesa One washing station. What could simply be a traditional Ethiopia lot filled with peachy, tea-like vibes, this year’s production is layered with shocks of watermelon juice, orangey citrus choirs and a hectic structure that shifts as quickly as summer weather! Truly a delight! \n",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:31.373Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
